module.exports = {
    TargetSelected: "PCARDDATA.TARGETSELECTED",
};


// WEBPACK FOOTER //
// ./src/actions/metadata/PCardActions.js